import thumbnailSimpleBar from './simple-bar.png';
import thumbnailGroupedBar from './grouped-bar.png';
import thumbnailStackedBar from './stacked-bar.png';
import thumbnail100StackedBar from './100--stacked-bar.png';
import thumbnailBarWithLabels from './bar-with-labels.png';
import thumbnailSimpleColumn from './simple-column.png';
import thumbnailGroupedColumn from './grouped-column.png';
import thumbnailStackedColumn from './stacked-column.png';
import thumbnail100StackedColumn from './100--stacked-column.png';
import thumbnailColumnWithNegativeValues from './column-with-negative-values.png';
import thumbnailSimplePie from './simple-pie.png';
import thumbnailSimpleDoughnut from './simple-doughnut.png';
import thumbnailPieInADoughnut from './pie-in-a-doughnut.png';
import thumbnailPieWithVariableRadius from './pie-with-variable-radius.png';
import thumbnailSimpleLine from './simple-line.png';
import thumbnailLineWithGaps from './line-with-gaps.png';
import thumbnailSimpleScatter from './simple-scatter.png';
import thumbnailSimpleBubble from './simple-bubble.png';
import thumbnailBubbleWithNegativeValues from './bubble-with-negative-values.png';
import thumbnailBubbleWithCategories from './bubble-with-categories.png';
import thumbnailSimpleArea from './simple-area.png';
import thumbnailStackedArea from './stacked-area.png';
import thumbnail100StackedArea from './100--stacked-area.png';
import thumbnailAreaWithNegativeValues from './area-with-negative-values.png';
import thumbnailSimpleHistogram from './simple-histogram.png';
import thumbnailHistogramWithSpecifiedBins from './histogram-with-specified-bins.png';
import thumbnailXyHistogramWithMeanAggregation from './xy-histogram-with-mean-aggregation.png';
import thumbnailMarketIndexTreemap from './market-index-treemap.png';
import thumbnailCrossLines from './cross-lines.png';
import thumbnailTimeAxisWithIrregularIntervals from './time-axis-with-irregular-intervals.png';
import thumbnailLogAxis from './log-axis.png';
import thumbnailRealTimeDataUpdates from './real-time-data-updates.png';
import thumbnailCombinationOfDifferentSeriesTypes from './combination-of-different-series-types.png';
import thumbnailChartCustomisation from './chart-customisation.png';
import thumbnailCustomMarkerShapes from './custom-marker-shapes.png';
import thumbnailCustomTooltips from './custom-tooltips.png';
import thumbnailPerMarkerCustomisation from './per-marker-customisation.png';

const thumbnails = {
    'simple-bar': thumbnailSimpleBar,
    'grouped-bar': thumbnailGroupedBar,
    'stacked-bar': thumbnailStackedBar,
    '100--stacked-bar': thumbnail100StackedBar,
    'bar-with-labels': thumbnailBarWithLabels,
    'simple-column': thumbnailSimpleColumn,
    'grouped-column': thumbnailGroupedColumn,
    'stacked-column': thumbnailStackedColumn,
    '100--stacked-column': thumbnail100StackedColumn,
    'column-with-negative-values': thumbnailColumnWithNegativeValues,
    'simple-pie': thumbnailSimplePie,
    'simple-doughnut': thumbnailSimpleDoughnut,
    'pie-in-a-doughnut': thumbnailPieInADoughnut,
    'pie-with-variable-radius': thumbnailPieWithVariableRadius,
    'simple-line': thumbnailSimpleLine,
    'line-with-gaps': thumbnailLineWithGaps,
    'simple-scatter': thumbnailSimpleScatter,
    'simple-bubble': thumbnailSimpleBubble,
    'bubble-with-negative-values': thumbnailBubbleWithNegativeValues,
    'bubble-with-categories': thumbnailBubbleWithCategories,
    'simple-area': thumbnailSimpleArea,
    'stacked-area': thumbnailStackedArea,
    '100--stacked-area': thumbnail100StackedArea,
    'area-with-negative-values': thumbnailAreaWithNegativeValues,
    'simple-histogram': thumbnailSimpleHistogram,
    'histogram-with-specified-bins': thumbnailHistogramWithSpecifiedBins,
    'xy-histogram-with-mean-aggregation': thumbnailXyHistogramWithMeanAggregation,
    'market-index-treemap': thumbnailMarketIndexTreemap,
    'cross-lines': thumbnailCrossLines,
    'time-axis-with-irregular-intervals': thumbnailTimeAxisWithIrregularIntervals,
    'log-axis': thumbnailLogAxis,
    'real-time-data-updates': thumbnailRealTimeDataUpdates,
    'combination-of-different-series-types': thumbnailCombinationOfDifferentSeriesTypes,
    'chart-customisation': thumbnailChartCustomisation,
    'custom-marker-shapes': thumbnailCustomMarkerShapes,
    'custom-tooltips': thumbnailCustomTooltips,
    'per-marker-customisation': thumbnailPerMarkerCustomisation,
};

export default thumbnails;